/**
 * Materials that appear in every list with the same supplier `id` (same catalog row).
 * Uses the first list's object as the canonical row when merging.
 * @param {Array<Array<{ id?: number }>>} lists
 * @returns {Array<Record<string, unknown>>}
 */
export function intersectMaterialListsBySupplierId(lists) {
  if (!Array.isArray(lists) || lists.length === 0) return [];
  const valid = lists.map((l) =>
    (Array.isArray(l) ? l : []).filter((m) => m != null && m.id != null)
  );
  if (valid.some((l) => l.length === 0)) return [];
  const byId = new Map(valid[0].map((m) => [m.id, m]));
  for (let i = 1; i < valid.length; i++) {
    const ids = new Set(valid[i].map((m) => m.id));
    for (const id of byId.keys()) {
      if (!ids.has(id)) byId.delete(id);
    }
  }
  return [...byId.values()];
}
